// extracted by mini-css-extract-plugin
module.exports = {"expandListButton":"AccordionButton_expandListButton__TTWCW","expandIcon":"AccordionButton_expandIcon__QzTtv","expanded":"AccordionButton_expanded__3o6xE"};